import { Outlet, Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useAuth from '../hooks/useAuth'
import LanguageSwitcher from './LanguageSwitcher'

export default function ClientLayout() {
  const { t } = useTranslation()
  const { user, profile, signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/login', { replace: true })
  }

  return (
    <div className="min-h-screen">
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link to="/client" className="flex items-center gap-3">
            <div className="w-9 h-9 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg flex items-center justify-center text-white font-display font-semibold text-sm shadow">
              CSI
            </div>
            <h1 className="font-display text-xl font-medium text-gray-800">
              {t('nav.yourSurvey')}
            </h1>
          </Link>

          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            <span className="text-sm text-gray-500 hidden sm:inline">
              {profile?.full_name || user?.email}
            </span>
            <Link
              to="/client/change-password"
              className="px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 rounded-lg transition-all hover:bg-gray-200"
            >
              {t('nav.changePassword')}
            </Link>
            <button
              onClick={handleSignOut}
              className="px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 rounded-lg transition-all hover:bg-gray-200"
            >
              {t('nav.signOut')}
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-5 py-6">
        <Outlet />
      </main>
    </div>
  )
}
